export enum DeckDesign {
  doubleDeck = 'doubleDeck',
  simpleDeck = 'simpleDeck',
  doubleDeckBlack = 'doubleDeckBlack',
  simpleDeckBlack = 'simpleDeckBlack',
}
